// extracted by mini-css-extract-plugin
export default {"thread":"SmsPreview_thread__dQMF8","sender":"SmsPreview_sender__H+SoX","bubble":"SmsPreview_bubble__I50GX","tplBadge":"SmsPreview_tplBadge__L605W"};